import ListButton from '../ListButton/ListButton'
import PopOut from '../PopOut/PopOut'
import classes from './ListPopOut.module.scss'
import type { PopperProps } from 'react-popper'
import type { ReactNode } from 'react'

export interface Props {
  counter?: number
  children: ReactNode
  title?: string
  isDisabled?: boolean
  placement?: PopperProps['placement']
  isPopOutAlign?: boolean
  hasFixWidth?: boolean
  label?: string
}

const ListPopOut = ({
  counter,
  children,
  title,
  isDisabled = false,
  placement = 'bottom',
  isPopOutAlign = false,
  hasFixWidth = true,
  label
}: Props) => {
  const triggerInfoButton = (ref: any, onClick: () => void, isOpen?: boolean) => (
    <ListButton
      counter={counter}
      isDisabled={isDisabled}
      isStayFocus={isOpen}
      label={label}
      onClick={onClick}
      ref={ref}
      title={title}
      withTooltips={false} // when info button is placed at the bottom, visibility of tooltips will cause vertical scrollbar to be visible and then the button is hard to click
    />
  )

  const widthClass = !hasFixWidth
    ? classes.noFixWidth
    : ''

  const getListPopOutClasses = () => [
    classes.ListPopOut,
    widthClass
  ].filter(classStyle => classStyle).join(' ')

  return (
    <PopOut
      isPopOutAlign={isPopOutAlign}
      placement={placement}
      trigger={triggerInfoButton}
    >
      <div className={getListPopOutClasses()}>
        {children}
      </div>
    </PopOut>
  )
}

export default ListPopOut
